<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div id="app" :class="vueAppClasses">
		<router-view @setAppClasses="setAppClasses" />
    <mam-subscrpit-dialog></mam-subscrpit-dialog>
    <mam-master-and-social-sub-account-edit-subscrpit-dialog></mam-master-and-social-sub-account-edit-subscrpit-dialog>
    <mam-sub-account-edit-subscrpit-dialog></mam-sub-account-edit-subscrpit-dialog>
    <open-mt4-account-dialog></open-mt4-account-dialog>
	</div>
</template>

<script>

import mamSubAccountEditSubscrpitDialog from '@/components/public/copy/dialog/mamSubAccountEditSubscrpitDialog'
import mamMasterAndSocialSubAccountEditSubscrpitDialog from '@/components/public/copy/dialog/mamMasterAndSocialSubAccountEditSubscrpitDialog'
import mamSubscrpitDialog from '@/components/public/copy/dialog/mamSubscrpitDialog'
import ResizeHandler from "@/mixins/ResizeHandler";
  import { queryConfig } from '@/api/home'
import themeConfig from '@/../themeConfig.js'

export default {
  components: {
    mamSubscrpitDialog,
    mamMasterAndSocialSubAccountEditSubscrpitDialog,
    mamSubAccountEditSubscrpitDialog,
  },
  data() {
    return {
      vueAppClasses: [],
    }
  },
  mixins:[ResizeHandler],
  mounted() {
    // 从后台读取数据,设置主题色 todo
    this.$vs.theme({
      primary:'#FE5924' // my new color
    })
    // console.log(this.$store.frame.windowWidth);
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  },
  async created() {
    // this.getConfig();
    let dir = this.$vs.rtl ? "rtl" : "ltr"
    document.documentElement.setAttribute("dir", dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    '$store.getters.theme'(val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl'(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
    }
  },
  methods: {
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      }
      else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      }
      else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    },
    // 窗口高度变化,侧边栏高度没有变化bug todo
    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },
    getConfig(){
      /*queryConfig({
        domainName: domain
      }).then((res) => {
        this.$store.commit('setConfig',res);
        this.setIconAndTitle(res);
      })*/
    },
    setIconAndTitle(res){
      // document.title = res.siteName || 'ALITA社区';
      var linkIcon = document.createElement("link");
      // rel="shortcut icon"
      linkIcon.rel = "shortcut icon";
      linkIcon.href = res.icon;
      var ohead=document.getElementsByTagName("head")[0];
      ohead.appendChild(linkIcon);
    }
  },

}

</script>
<style lang="scss">

</style>
